import AjaxManager from '../ajaxManager';
import Form from '../../entity/form';
import AvailableDatesCalendarManager from './availableDatesCalendarManager';
import SliderManager from '../slider/sliderManager';

export default class BookingConfigurator {
    constructor() {
        this.booking = myApp.bookingService.booking;
        this.ajaxManager = new AjaxManager();
        const sliderManager = new SliderManager();
        this.availableDatesCalendarManager = new AvailableDatesCalendarManager(sliderManager);
        this.showDatesCalendar = true;
        this.eventDelegation();
        this.notifyChangeMinimumStayDates();
    }

    eventDelegation() {
        let body = $('body');
        this.showChildrenAgesSelect(parseInt($('#num_children').val()));
        body.on('change', '#num_children', (event) => {
            const currentTarget = event.currentTarget;
            this.showChildrenAgesSelect(parseInt($(currentTarget).val()));
        });

        body.on('change', '[data-childrenage]', (event) => {
            const currentTarget = event.currentTarget;
            this.checkDiscounts($(currentTarget).val(), $(currentTarget));
        });

        body.on('click', '[data-entity=date]', (event) => {
            const elem = $(event.currentTarget);
            const dateAction = elem.data('dateAction');
            switch (dateAction) {
                case 'minStay':
                    let suggestedChollo = elem.parent().attr('data-suggested');
                    let suggestedCholloText = '';
                    let suggestedCategoryText = '';
                    let nights = '';

                    if (suggestedChollo) {
                        let cholloValue = JSON.parse(elem.parent().attr('data-value'));
                        suggestedCholloText = cholloValue.suggestedCholloText;
                        suggestedCategoryText = cholloValue.suggestedCategoryText;
                    } else {
                        nights = elem.parent().attr('data-value');
                    }

                    this.selectMininumStayDate(
                        suggestedCategoryText,
                        suggestedCholloText,
                        nights,
                        suggestedChollo,
                        elem.parent().attr('data-chollo-id'),
                        elem.parent().attr('data-tag-chollo'),
                    );
                    break;
                case 'availabilityAlert':
                    let alertDateElement = elem.parent();
                    let dataId = alertDateElement.attr('data-value');
                    let startDateNum = alertDateElement.find('[data-attribute=start-date-num]').text();
                    let startDateDay = alertDateElement.find('[data-attribute=start-date-day]').text();
                    let startDateMonth = alertDateElement.find('[data-attribute=start-date-month]').text();

                    let endDateNum = alertDateElement.find('[data-attribute=end-date-num]').text();
                    let endDateDay = alertDateElement.find('[data-attribute=end-date-day]').text();
                    let endDateMonth = alertDateElement.find('[data-attribute=end-date-month]').text();
                    this.showAvailabilityAlert(
                        dataId,
                        startDateNum,
                        startDateDay,
                        startDateMonth,
                        endDateNum,
                        endDateDay,
                        endDateMonth,
                    );
                    break;
                case 'loginModal':
                    myApp.user.loginManager.openLoginModal();
                    myApp.customModalManager.openModal('#userModal');
                    break;
                default:
                    this.selectDate(elem, elem.parent().attr('data-startdate'), elem.parent().attr('data-enddate'));
                    break;
            }
        });

        $('#formulari_pas2 [data-combination]').click((event) => {
            const currentTarget = event.currentTarget;
            if (currentTarget.dataset.roomDataSheet) {
                return;
            }

            const currentCombination = document.querySelector('#formulari_pas2 [data-combination].combination-active');
            if (currentCombination) {
                currentCombination.classList.remove('combination-active');
            }
            currentTarget.classList.add('combination-active');
            this.setRoomDistribution(currentTarget);
            this.refreshSummaryCancelationPolicies(currentTarget);
            if ($('[data-entity="cancel-policies"]').length > 0) {
                myApp.bookingSummaryService.recalculateCancelPolicies();
            }
        });

        body.on('click', '[data-complements]', () => {
            this.selectComplement();
        });

        $('[data-action="show-calendar"]').click((event) => {
            event.stopPropagation();
            event.preventDefault();
            $('[data-attribute="available-dates-calendar-container"]').addClass('show-dates-calendar-container');
            myApp.browserHistoryManager.addState('[data-attribute="available-dates-calendar-container"]');
            $(body).addClass('fix-scroll-xs');
            this.availableDatesCalendarManager.resizeCalendar();

            let calendarContainer = $('[data-calendar-container="available-dates-calendar"]');
            let monthsHeight = 0;
            const monthsContainer = calendarContainer.find('.flatpickr-days');
            const monthsSelectorContainer = calendarContainer.find('[data-entity="dates-calendar-options-container"]');
            if (monthsContainer.length > 0) {
                monthsHeight = monthsContainer.height();
            }

            if (monthsSelectorContainer.length > 0) {
                monthsHeight += monthsSelectorContainer.height();
            }

            const datesCalendarLegendContainer = calendarContainer.find('[data-entity="dates-calendar-legend"]');
            if (datesCalendarLegendContainer.length > 0) {
                if (monthsHeight > 0 && datesCalendarLegendContainer) {
                    const flatpickrInnerContainer = calendarContainer.find('.flatpickr-innerContainer');
                    if (flatpickrInnerContainer.length > 0) {
                        const totalHeight = monthsHeight + datesCalendarLegendContainer.height();
                        flatpickrInnerContainer.css('min-height', totalHeight + 'px');
                    }
                }
            }
        });

        $('[data-attribute="calendar-go-back"]').click((event) => {
            event.stopPropagation();
            event.preventDefault();
            myApp.browserHistoryManager.removeState('[data-attribute="available-dates-calendar-container"]');
        });

        $('[data-attribute="available-dates-calendar-container"]').on('pop-state', (e) => {
            $('[data-attribute="available-dates-calendar-container"]').removeClass('show-dates-calendar-container');
            $(body).removeClass('fix-scroll-xs');
        });

        window.addEventListener('resize', () => {
            if (this.showDatesCalendar) {
                this.availableDatesCalendarManager.resizeCalendar();
            }
        });

        $('[data-modal-type=complement]').click((event) => {
            const currentTarget = event.currentTarget;
            event.stopPropagation();
            event.scrollToReview = $(currentTarget).data('entity') == 'ratingContainer';
            myApp.step2Manager.showComplementModal(event);
        });

        body.on('click', '[data-selectcomplement]', (event) => {
            event.stopPropagation();
            this.selectComplement();
        });

        body.on('change', '[data-selectcomplement]', (event) => {
            event.stopPropagation();
            this.selectComplement();
        });

        $('[data-payment]').click((event) => {
            this.setPaymentMethod(event);
        });

        $('[data-paymentamount]').click((event) => {
            const currentTarget = event.currentTarget;
            this.setPaymentAmount(currentTarget);
        });

        body.on('click', '[data-payment]', function () {
            myApp.bookingSummaryService.updateTotalPrice();
        });

        body.on('click', '[name=date-alert-notify]', (event) => {
            const currentTarget = event.currentTarget;
            this.showResponseAjaxCallUserWebCholloDate(currentTarget.id);
        });
    }

    refreshDatesPrice() {
        this.calculateDatesPrice();
        $('[data-entity=bookingelem]').change((event) => {
            const currentTarget = event.currentTarget;
            myApp.browserStorageService.setItem($(currentTarget).attr('data-storagename'), $(currentTarget).val());
            this.setPeopleInBooking();
            this.calculateDatesPrice();
        });
    }

    calculateDatesPrice() {
        const form = new Form('datesForm');
        const formData = new FormData(document.querySelector('#datesForm'));
        const numChildren = formData.get('num_nens');
        if (numChildren) {
            let numChildrenAges = [];
            let childrenAge = null;

            for (let i = 1; i <= numChildren; i++) {
                childrenAge = formData.get('nen_' + i);
                if (childrenAge !== '') {
                    numChildrenAges.push(childrenAge);
                }
            }
            if (numChildren != numChildrenAges.length) {
                return;
            }
        }
        let searcherDate = '';
        let startDay = '';
        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('data')) {
            searcherDate = searchParams.get('data');
        } else if (searchParams.has('startDay')) {
            startDay = 'startDay=' + searchParams.get('startDay');
        } else if (searchParams.has('start')) {
            startDay = 'startDay=' + searchParams.get('start');
        }

        $('[data-entity="date-selector-panel"]').attr('data-show', 'loader');
        $('[data-entity="date-unavailable-contact-panel"]').addClass('hidden');

        $.ajax({
            url: myApp.config.routing.getBookingDatesByPeople + '?' + searcherDate + startDay,
            data: form.getForm().serialize(),
            type: 'POST',
            success: (data) => {
                if (data.status == 400) {
                    return;
                }
                if (data.view) {
                    if (data.status == 204) {
                        let unavailableDates = $('[data-entity="unavailable-dates"]');
                        let datesUnavailableContact = $('[data-entity="dates-unavailable-contact"]');
                        unavailableDates.html(data.view);
                        if (data.datesUnavailableContact !== '') {
                            datesUnavailableContact.html(data.datesUnavailableContact);
                            $('[data-entity="date-unavailable-contact-panel"]').removeClass('hidden');
                        }
                        $('[data-entity="date-selector-panel"]').attr('data-show', 'error');

                        $('[data-entity="datevalue"]').removeAttr('value');

                        $('[name="guardar_pas1"]').addClass('disabled');
                    } else if (data.status === 200) {
                        if (this.showDatesCalendar) {
                            $('[data-entity="date-selector-panel"]').attr('data-show', 'calendar');
                            const cholloDateAlerts = data.cholloDateAlerts;
                            this.availableDatesCalendarManager.initialize(
                                data.dates,
                                data.hasApartment,
                                searchParams.has('startDay') ? null : data.startDay,
                                cholloDateAlerts,
                            );
                        } else {
                            let datesSelector = $('[data-entity="dates-table"]');
                            datesSelector.html(data.view);
                            $('[data-entity="date-selector-panel"]').attr('data-show', 'list');
                        }
                        $('[name="guardar_pas1"]').removeClass('disabled');
                        $('[data-entity="date-unavailable-contact-panel"]').addClass('hidden');
                        myApp.dateFetchService.checkIfHasSelectedDates();
                    }
                }
            },
        });
    }

    refreshSummaryCancelationPolicies(combinationElem) {
        const combinationId = $(combinationElem).data('input-value');
        $('[data-cancelpolicies-value]').hide();
        $('[data-cancelpolicies-value="' + combinationId + '"]').show();
    }

    initializeBooking() {
        if (!myApp.step2Manager.jsonRoomDistribution) {
            return;
        }
        $.each(
            myApp.step2Manager.jsonRoomDistribution[$('[data-combination]').data('combination') - 1],
            (index, event) => {
                this.booking.addRoom(event);
            },
        );
    }

    setDataFromBrowserStorage() {
        if (myApp.browserStorageService.getItem('persones') != null) {
            $('#num_people').val(myApp.browserStorageService.getItem('persones'));
        }
        if (myApp.browserStorageService.getItem('num_nens') != null) {
            $('#num_children').val(myApp.browserStorageService.getItem('num_nens'));
        }

        if (myApp.browserStorageService.getItem('num_nens') > 0) {
            $('[data-entity=children]').show();
        }
        for (var i = 1; i < parseInt(myApp.browserStorageService.getItem('num_nens')) + 1; i++) {
            this.setChildrenAgesInDOM(i, myApp.browserStorageService.getItem('selec_nen_' + i));
            this.checkDiscounts(myApp.browserStorageService.getItem('selec_nen_' + i), $('#children_age_' + i));
        }
        this.setPeopleInBooking();
        this.checkDiscounts(null, null);
    }

    removeDataFromBrowserStorage() {
        for (let i = 1; i < parseInt(myApp.browserStorageService.getItem('num_nens')) + 1; i++) {
            myApp.browserStorageService.removeItem('selec_nen_' + i);
        }
        myApp.browserStorageService.removeItem('persones');
        myApp.browserStorageService.removeItem('num_nens');
    }

    showChildrenAgesSelect(num) {
        $('[data-entity=groupchildage]').hide();
        for (let i = 0; i < num + 1; i++) {
            this.setChildrenAgesInDOM(i, 0);
            this.checkDiscounts(null, null);
        }
    }

    setChildrenAgesInDOM(num, val) {
        if (
            val != null &&
            val != '' &&
            val != 'null' &&
            $('#children_age_' + num + ' option[value="' + val + '"]').length > 0
        ) {
            $('#children_age_' + num).val(val);
        }
        $('[data-groupchildage=' + num + ']').show();
        if ($('#num_children').val() > 0) {
            $('[data-entity=children]').show();
        } else {
            $('[data-entity=children]').hide();
        }
    }

    checkDiscounts(age, select) {
        if (age == null || $('[data-entity=children]').is(':hidden')) {
            $('[data-entity=alert]').hide();
        } else {
            $.each(myApp.bookingService.booking.discounts, function (i, item) {
                let count = $('*[data-alert="' + item.type + '"]').length;
                if (age >= parseInt(item.min_age) && age <= parseInt(item.max_age)) {
                    if (select.attr('data-alert') && count >= 2) {
                        $('#' + select.attr('data-alert')).hide();
                        select.attr('data-alert', '');
                    }
                    select.attr('data-alert', item.type);
                    $('#' + item.type).show();
                    $('#' + item.type + ' span').text(item.text);
                    return false;
                } else {
                    if (select.attr('data-alert') && count == 1) {
                        $('#' + select.attr('data-alert')).hide();
                    }
                }
            });
        }

        const childrenDiscountMaxAgeContainer = $('#children-discount-max-age');
        if (childrenDiscountMaxAgeContainer.length > 0) {
            const ageLimit = childrenDiscountMaxAgeContainer.data('ageLimit');
            if (this.booking.hasChildrenWithAgeOrLess(ageLimit)) {
                childrenDiscountMaxAgeContainer.show();
            } else {
                childrenDiscountMaxAgeContainer.hide();
            }
        }
    }

    setPeopleInBooking() {
        this.booking.setOnlyAdults($('#onlyAdults').val());
        this.booking.setAdults($('#num_people').val());
        this.booking.setChildren($('#num_children').val());
        if (this.booking.children > 0) {
            this.setChildrenAgesInBooking($('#num_children').val());
        }
        myApp.bookingSummaryService.updateView();
    }

    setChildrenAgesInBooking(num) {
        this.booking.childrenAges.length = 0;
        for (let i = 1; i <= num; i++) {
            this.booking.setChildrenAges($('#children_age_' + i).val());
        }
    }

    selectDate(elem, start, end) {
        $('[data-entity=cloned-date]').empty();
        $('[data-entity=searched-dates-container]').hide();
        myApp.domManager.toggleClass(elem.parent(), $('tr'), 'active');
        this.booking.setStartDate(start);
        this.booking.setEndDate(end);
        myApp.bookingSummaryService.updateView();
        $('[data-entity=datevalue]').val(elem.parent().attr('data-value'));
        this.showContinueButton();
        $('#datesForm').formValidation('revalidateField', 'data');
        this.updateBookingSummaryByDates(
            elem.parent().data('current-chollo-id'),
            start,
            end,
            elem.parent().attr('data-value'),
        );
    }

    setDate(startDate, endDate) {
        let start = myApp.dateFormatter.getShortDate(startDate);
        let end = myApp.dateFormatter.getShortDate(endDate);
        $('[data-entity=cloned-date]').empty();
        $('[data-entity=searched-dates-container]').hide();
        this.booking.setStartDate(start);
        this.booking.setEndDate(end);
        myApp.bookingSummaryService.updateView();
        $('[data-entity=datevalue]').val(myApp.bookingConfigurator.availableDatesCalendarManager.getDateId(startDate));
        this.showContinueButton();
        $('#datesForm').formValidation('revalidateField', 'data');
        this.updateBookingSummaryByDates(
            document.querySelector('input[name="id_chollo"]').value,
            start,
            end,
            myApp.bookingConfigurator.availableDatesCalendarManager.getDateId(startDate),
        );
    }

    updateBookingSummaryByDates(
        cholloId,
        checkIn,
        checkOut,
        currentDateId,
        outBoundTransportAccommodation = null,
        returnTransportAccommodation = null,
    ) {
        let cancelPoliciesLabelContainer = $('[data-entity="free-cancel-policies-label"]');
        let transportsContainer = $('[data-content="transports"]');

        let people = $('#num_people').val();
        let children = $('#num_children').val();
        let childrenAges = '';

        for (let i = 1; i <= children; i++) {
            childrenAges += $('#children_age_' + i).val() + (i != children ? ';' : '');
        }

        const data = {
            cholloId: cholloId,
            checkIn,
            checkOut,
            currentDateId: currentDateId,
            numAdults: people,
            numChildren: children,
            childrenAges: childrenAges,
            outBoundTransportAccommodation: outBoundTransportAccommodation,
            returnTransportAccommodation: returnTransportAccommodation,
        };

        const callback = function callback(response) {
            cancelPoliciesLabelContainer.html(response.cancelPolicyLabel);
            transportsContainer.html(response.transports);
            if (response.transportData) {
                $('#transport-container').show();
                $('#transport-container').html(response.transportData);

                if (response.hotelStartDate && response.hotelEndDate) {
                    $('[data-entity="hotelDates"] [data-reservation="start"]').text(response.hotelStartDate);
                    $('[data-entity="hotelDates"] [data-reservation="end"]').text(response.hotelEndDate);
                    $('[data-entity="hotelDates"]').show();
                }

                if (response.totalPrice) {
                    $('[data-field="totalprice"]').text(response.totalPrice + " €");
                }

                if (response.preferentialEntry) {
                    $('#preferentialEntry').show();
                }

                if ($('#xsReturnSummary').length && $('#xsOutboundSummary').length) {
                    $('#xsReturnSummary [data-entity="transport-accommodation"]').text(
                        $(
                            '#transport-container [data-transport-summary="return"] [data-entity="transport-accommodation"]',
                        ).text(),
                    );
                    $('#xsOutboundSummary [data-entity="transport-accommodation"]').text(
                        $(
                            '#transport-container [data-transport-summary="outbound"] [data-entity="transport-accommodation"]',
                        ).text(),
                    );
                }
            }
        };

        const url = myApp.config.routing.bookingSummaryByDates;

        this.ajaxManager.ajaxCall('GET', url, data, callback);
    }

    selectMininumStayDate(
        suggestedCategoryText,
        suggestedCholloText,
        nights,
        currentCholloId,
        suggestedCholloId,
        cholloTag,
        startDate = null,
    ) {
        const minStayDate = $('#cholloMinStayDate');
        const hrefLink = myApp.config.routing.step2;
        let hrefLinkReplaced = hrefLink.replace('idChollo', suggestedCholloId);
        hrefLinkReplaced = hrefLinkReplaced.replace('tagChollo', cholloTag);

        const url = new URL(window.location.protocol + '//' + window.location.hostname + hrefLinkReplaced);
        if (!suggestedCategoryText) {
            suggestedCholloText = nights + ' ' + myApp.translator['book.dates.minimumstaydates_modal.nigths'];
            suggestedCategoryText = '';
        } else {
            url.searchParams.append('suggestedChollo', currentCholloId);
        }

        if (startDate) {
            url.searchParams.append('startDay', startDate);
        }
        url.searchParams.append('nc', '');
        minStayDate.find("[data-element='link-minimum-stay-dates']").attr('href', url);
        minStayDate.find('[data-nights]').text(suggestedCholloText ?? '');
        minStayDate.find('[data-category]').text(suggestedCategoryText);
        myApp.customModalManager.openModal('#' + minStayDate.attr('id'));
    }

    notifyChangeMinimumStayDates() {
        const notifyModal = document.querySelector('#notifyModal');
        if (myApp.urlManager.checkUrlParam('nc') && notifyModal) {
            myApp.customModalManager.openModal('#notifyModal', true);
            const urlGetParams = new URLSearchParams(window.location.search);
            if (urlGetParams.has('startDay')) {
                const startDay = urlGetParams.get('startDay');
                notifyModal.addEventListener('pop-state', () => {
                    const dayContainer = document.querySelector('[aria-label="' + startDay + '"]');
                    if (dayContainer) {
                        dayContainer.click();
                    }
                });
            }
        }
    }

    showContinueButton() {
        $('[data-entity=continue]').show();
        $('#footer').addClass('button-affix');
        $('.scroll-top-wrapper').addClass('bottom-higher');
    }

    hideContinueButton() {
        $('[data-entity=continue]').hide();
        $('#footer').removeClass('button-affix');
        $('.scroll-top-wrapper').removeClass('bottom-higher');
    }

    selectComplement() {
        this.setDiscounts();
        this.setInsurance();
        this.setActivities();
        if ($('[data-entity="cancel-policies"]').length > 0) {
            myApp.bookingSummaryService.recalculateCancelPolicies();
        }
        myApp.bookingSummaryService.updateView();
    }

    setRoomDistribution(elem) {
        $('[data-roomdistribution]').val($(elem).data('combination'));
        $('[data-selecteddistribution]').attr('data-selecteddistribution', $(elem).data('combination'));
        this.booking.rooms = [];
        if ($('[data-roomdistribution]').length > 0) {
            $.each(myApp.step2Manager.jsonRoomDistribution[$(elem).data('combination') - 1], (index, event) => {
                this.booking.addRoom(event);
            });
        }
        myApp.bookingSummaryService.updateView();
    }

    setActivities() {
        this.booking.activities = [];
        $.each($('[data-activities=value]'), (index, event) => {
            if ($(event).val() > 0) {
                const activity = myApp.step2Manager.jsonActivities[$(event).data('complementid')];
                this.booking.addActivity(activity, $(event).val());
            }
        });
    }

    setDiscounts() {
        this.booking.userDiscounts = [];
        $.each($('[data-selecteddiscounts]'), (index, event) => {
            $(event).parent('[data-complements=discount]').removeClass('disabled');
            if ($(event).val() > 0) {
                const userDiscount = myApp.step2Manager.jsonUserDiscounts[$(event).data('discount')];
                this.booking.addUserDiscount(userDiscount);
            }
        });
        if (this.booking.getTotalPrice() == 0) {
            myApp.bookingConfigurator.deactivateDiscount();
        }
    }

    setInsurance() {
        this.booking.insurances = [];
        $.each($('[data-insurance=value]'), (index, event) => {
            if ($(event).val() > 0) {
                const insurance = myApp.step2Manager.jsonInsurances[$(event).data('complementid')];
                this.booking.addInsurance(insurance, $(event).val());
            }
        });
    }

    deactivateDiscount() {
        if (this.booking.userDiscounts.length > 1) {
            let discountPrice = 0;
            let lowerDiscount;
            let key;
            for (let i = 0; i < this.booking.userDiscounts.length; i++) {
                if (
                    (discountPrice > 0 && discountPrice > parseInt(this.booking.userDiscounts[i].price)) ||
                    discountPrice == 0
                ) {
                    lowerDiscount = this.booking.userDiscounts[i];
                    discountPrice = parseInt(this.booking.userDiscounts[i].price);
                    key = i;
                }
            }
            if (this.booking.getTotalPrice() - discountPrice <= 0) {
                delete this.booking.userDiscounts[key];
                $('[data-input=' + lowerDiscount.inputName + ']').removeClass('active-item');
                $('[data-input=' + lowerDiscount.inputName + ']').addClass('disabled');
                $('[name=' + lowerDiscount.inputName + ']').val(0);
                this.setDiscounts();
            }
        }
    }

    setPaymentMethod(event) {
        const currentTarget = event.currentTarget;
        const inputValue = $(currentTarget).data('input-value');
        let showInfoClicked = $(currentTarget).closest('[data-payment-info]').length;
        if (!showInfoClicked) {
            $('[name="pagament"]').val(inputValue);
            this.booking.setPaymentMethod(inputValue);
            myApp.domManager.toggleClass($(currentTarget), $('[data-payment]'), 'active-item');
        }

        const dataPayment = $(currentTarget).attr('data-payment');
        $('[data-payment]').each((event) => {
            const currentTarget = event.currentTarget;
            if ($(currentTarget).attr('data-payment') !== dataPayment) {
                $(currentTarget).find('.collapse.in').collapse('hide');
            }
        });
    }

    setPaymentAmount(elem) {
        myApp.domManager.toggleClass($(elem), $('[data-paymentamount]'), 'active-item');
        $('[name="pago_fraccionado"]').val($(elem).data('input-value'));
        this.booking.setPartialPayment($(elem).data('input-value'));
    }

    sendTransferEmail(bookingId, token) {
        const data = {
            bookingId: bookingId,
            token: token,
        };

        const callback = function callback(response) {};

        const url = myApp.config.routing.sendPrebookingTransferEmail;

        this.ajaxManager.ajaxCall('POST', url, data, callback);
    }

    showAvailabilityAlert(dataId, startDateNum, startDateDay, startDateMonth, endDateNum, endDateDay, endDateMonth) {
        let alertModal = $('#dates_alert');
        const calendarItem = document.querySelector('[data-chollo-date-id="' + dataId + '"]');
        if (calendarItem) {
            const calendarItemIcon = calendarItem.querySelector('i.ci-bell-fill.calendar-day-reminder-active');
            if (calendarItemIcon) {
                this.showResponseAjaxCallUserWebCholloDate(dataId);
                return;
            }
        }
        alertModal.find('[name="date-alert-notify"]').attr('id', dataId);
        alertModal.find('[data-entity="start"][data-date="day"]').text(startDateNum);
        alertModal
            .find('[data-entity="start"][data-date="weekday"]')
            .text(startDateDay[0].toUpperCase() + startDateDay.slice(1));
        alertModal.find('[data-entity="start"][data-date="month"]').text(startDateMonth);

        alertModal.find('[data-entity="end"][data-date="day"]').text(endDateNum);
        alertModal
            .find('[data-entity="end"][data-date="weekday"]')
            .text(endDateDay[0].toUpperCase() + endDateDay.slice(1));
        alertModal.find('[data-entity="end"][data-date="month"]').text(endDateMonth);

        myApp.customModalManager.openModal('#dates_alert');
    }

    showResponseAjaxCallUserWebCholloDate(dateId) {
        const callback = function callback(response) {
            const cholloDateCalendarItem = document.querySelector('[data-chollo-date-id="' + dateId + '"]');
            if (cholloDateCalendarItem) {
                const cholloDateIcon = cholloDateCalendarItem.querySelector('i.ci-bell-fill');
                if (cholloDateIcon) {
                    cholloDateIcon.classList.remove('calendar-day-reminder');
                    cholloDateIcon.classList.add('calendar-day-reminder-active');
                }
            }
            let modalId = '#dates_alert_response';
            let modalResponse = $(modalId);
            modalResponse.find('[name="response-title"]').text(response.messages.title);
            modalResponse.find('[name="response-notification"]').text(response.messages.notification);
            modalResponse.find('[name="response-reminder"]').text(response.messages.reminder);
            let modalIcon = modalResponse.find('[data-entity="modal-body"] i');
            if (modalIcon) {
                modalIcon.removeClass('ci-circle-check ci-circle-warning ci-circle-cross color-success color-warning color-danger');
                modalIcon.addClass(response.messages.icon);
            }

            let modalHeaderIcon = modalResponse.find('[data-entity="custom-modal-title"] i');
            if (modalHeaderIcon) {
                modalHeaderIcon.removeClass('ci-circle-check ci-circle-warning ci-circle-cross color-success color-warning color-danger');
                modalHeaderIcon.addClass(response.messages.icon);
            }
            
            myApp.customModalManager.closeModal('#dates_alert');

            myApp.customModalManager.openModal(modalId, true);
        };

        let url = myApp.config.routing.userWebDateRequest + '?cholloDateId=' + dateId;

        this.ajaxManager.ajaxCall('POST', url, null, callback);
    }
}
